import * as Yup from "yup";
import * as moment from "moment";

const getBuyBackStartDate = () => {
  const buyBackFeeStartDate = new Date();
  const startDateValue = moment(buyBackFeeStartDate).format("MM/DD/YYYY");
  return startDateValue;
}

const getBuyBackEndDate = () => {
  const buyBackFeeEndDate = new Date();
  buyBackFeeEndDate.setFullYear(buyBackFeeEndDate.getFullYear() + 1);
  const endDateValue = moment(buyBackFeeEndDate).format("MM/DD/YYYY");
  return endDateValue;
}


export const getBuyBackEmptyFormData = () => {
  return {
    vendorLocationId: "",
    pickupPalletType: "",
    customerFee: "",
    vendorFee: "",
    rateStartDate: getBuyBackStartDate(),
    rateExpirationDate: getBuyBackEndDate(),
    comment: ""
  }
}

export function getBuyBackFeeFormInitialValues(formData) {
  return (
    {
      customerName: "",
      customerLocationId: "",
      buyBackFormData: [
        { ...getBuyBackEmptyFormData() }
      ]
    }
  )
}


export const VALIDATION_SCHEMA = () => {
  let schemaAttributes = {
    customerLocationId: Yup.string().required('Customer Location Name is required'),
    customerName: Yup.string().required('Customer Name is required'),
    buyBackFormData: Yup.array().of(
      Yup.object().shape({
        vendorLocationId: Yup.string().required('BuyBack Vendor is required'),
        pickupPalletType: Yup.string().required('Pallet Type is required'),
        customerFee: Yup.number().required('Customer Price is required').min(0, 'Customer Price must be greater than or equal to 0'),
        vendorFee: Yup.number().required('Vendor Price is required').min(0, 'Vendor Price must be greater than or equal to 0'),
        rateStartDate: Yup.date()
          .typeError('Start Date must be a valid date')
          .nullable()
          .required('Start Date is required')
          .test('start-date-before-end', 'Start Date must be before End Date', function(value) {
            const { rateExpirationDate } = this.parent;
            if (!rateExpirationDate || !value) return true; // No expiration date provided, so validation passes
            return moment(value, 'YYYY-MM-DD').isSameOrBefore(rateExpirationDate, 'day');
          }),
        rateExpirationDate: Yup.date()
          .typeError('End Date must be a valid date')
          .nullable()
          .required('End Date is required')
          .test('end-date-after-start', 'End Date must be after Start Date', function(value) {
            const { rateStartDate } = this.parent;
            if (!rateStartDate || !value) return true; // No start date provided, so validation passes
            return moment(value, 'YYYY-MM-DD').isSameOrAfter(rateStartDate, 'day');
          }),
        comment: Yup.string().max(200, 'Comment must be at most 200 characters'),
      })
    ),
  };

  return Yup.object().shape(schemaAttributes).noUnknown().strict(false);
};


export const getBuyBackAddNewFeeItemFormInitialValues = (editFeeItemData, editVendorData) => {
  return {
    vendorLocationId: editVendorData?.vendorLocationId ?? "",
    pickupPalletType: editFeeItemData?.pickupPalletType ?? "",
    customerFee: editFeeItemData?.customerFee ?? "",
    vendorFee: editFeeItemData?.vendorFee ?? "",
    rateStartDate: editFeeItemData?.rateStartDate ?? getBuyBackStartDate(),
    rateExpirationDate: editFeeItemData?.rateExpirationDate ?? getBuyBackEndDate(),
    comment: editFeeItemData?.comment ?? ""
  }
}


export const VALIDATION_SCHEMA_ADD_ITEM_FORM = () => {
  let schemaAttributes = {
    vendorLocationId: Yup.string().required('BuyBack Vendor is required'),
    pickupPalletType: Yup.string().required('Pallet Type is required'),
    customerFee: Yup.number().required('Customer Price is required').min(0, 'Customer Price must be greater than or equal to 0'),
    vendorFee: Yup.number().required('Vendor Price is required').min(0, 'Vendor Price must be greater than or equal to 0'),
    rateStartDate: Yup.date()
      .typeError('Start Date must be a valid date')
      .nullable()
      .required('Start Date is required')
      .test('start-date-before-end', 'Start Date must be before End Date', function(value) {
        const { rateExpirationDate } = this.parent;
        if (!rateExpirationDate || !value) return true; // No expiration date provided, so validation passes
        return moment(value, 'YYYY-MM-DD').isSameOrBefore(rateExpirationDate, 'day');
      }),
    rateExpirationDate: Yup.date()
      .typeError('End Date must be a valid date')
      .nullable()
      .required('End Date is required')
      .test('end-date-after-start', 'End Date must be after Start Date', function(value) {
        const { rateStartDate } = this.parent;
        if (!rateStartDate || !value) return true; // No start date provided, so validation passes
        return moment(value, 'YYYY-MM-DD').isSameOrAfter(rateStartDate, 'day');
      }),
    comment: Yup.string().max(200, 'Comment must be at most 200 characters'),
  }
  return Yup.object().shape(schemaAttributes);
}


